document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.vm-video-card').forEach(function (card) {
    var video = card.querySelector('video');
    var button = card.querySelector('.vm-video-card__play');
    if (!video || !button) return;

    video.muted = true;
    video.defaultMuted = true;
    video.volume = 0;

    function pauseOtherVideos() {
      document.querySelectorAll('.vm-video-card video').forEach(function (other) {
        if (other !== video) {
          other.pause();
          other.closest('.vm-video-card').classList.remove('is-playing');
        }
      });
    }

    button.addEventListener('click', function () {
      pauseOtherVideos();
      video.muted = true;
      video.volume = 0;
      video.play();
      card.classList.add('is-playing');
    });

    video.addEventListener('click', function () {
      if (video.paused) {
        pauseOtherVideos();
        video.muted = true;
        video.volume = 0;
        video.play();
        card.classList.add('is-playing');
      } else {
        video.pause();
        card.classList.remove('is-playing');
      }
    });

    video.addEventListener('pause', function () {
      card.classList.remove('is-playing');
    });
    video.addEventListener('ended', function () {
      card.classList.remove('is-playing');
    });
  });
});
